<template>
  <div
    id="searchBox"
    class="searchBox"
    :style="{
      minWidth: '400px'
    }"
  >
    <v-menu
      offset-y
      min-width="100%"
      max-width="100%"
      attach="#searchBox"
      transition="scale-y-transition"
      :value="filterActive"
      :close-on-content-click="false"
      :bottom="true"
      :tile="false"
    >
      <template v-slot:activator="{ on, attrs, value }">
        <v-autocomplete
          v-model="model"
          :loading="isLoading"
          :items="items"
          :search-input.sync="search"
          :validate-on-blur="false"
          type="search"
          solo
          flat
          no-filter
          hide-no-data
          hide-details
          class="w-100"
          background-color="#fff"
          prepend-inner-icon="mdi-magnify"
          append-icon="mdi-chevron-down"
          :label="$t('headband.search.placeholder')"
          :placeholder="$t('headband.search.placeholder')"
          :menu-props="{
            overflowY: true,
            closeOnClick: true, 
            closeOnContentClick: true,
          }"
          @click:append="filterActive = !value"
          @click:prepend-inner="handlerSubmit"
          @keyup.enter.native="handlerSubmit"
          v-bind="attrs"
          v-on="on"
        >
        </v-autocomplete>
      </template>
      <template v-slot:default>
        <v-card>
          <v-card-text class="pb-0">
            <p class="subtitle-1 font-weight-bold text--primary mb-0">
              {{$t('theme.searchFilters')}}
            </p>
          </v-card-text>
          <v-list class="pb-5">
            <v-list-item>
              <v-select
                flat
                multiple
                small-chips
                return-object
                clearable
                v-model="valueLanguages"
                :items="filterLanguages"
                item-value="key"
                :item-text="`name_${$i18n.locale}`"
                :label="$t('theme.filterLanguages')"
                :menu-props="{
                  closeOnContentClick: true,
                  auto: true,
                  overflowY: true
                }"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">
                    <languages :data="[item.key.toLowerCase()]" />
                  </span>
                  <span v-if="index === 1">
                    <languages :data="[item.key.toLowerCase()]" />
                  </span>
                  <span v-if="index === 2">
                    <languages :data="[item.key.toLowerCase()]" />
                  </span>
                  <span v-if="index === 3">
                    <languages :data="[item.key.toLowerCase()]" />
                  </span>
                  <span v-if="index === 4">
                    <languages :data="[item.key.toLowerCase()]" />
                  </span>
                  <span
                    v-if="index === 5"
                    class="grey--text caption"
                  >({{$tc('theme.others', valueLanguages.length - 5)}})</span>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-icon class="mt-0 mb-0">
                    <languages :data="[item.key.toLowerCase()]" />
                  </v-list-item-icon>
                  {{ item[`name_${$i18n.locale}`] }}
                </template>
              </v-select>
            </v-list-item>
            <v-list-item>
              <v-select
                flat
                multiple
                small-chips
                return-object
                clearable
                v-model="valueMarkets"
                :items="filterMarkets"
                item-value="key"
                :item-text="`name_${$i18n.locale}`"
                :label="$t('theme.filterMarkets')"
                :menu-props="{
                  closeOnContentClick: true,
                  auto: true,
                  overflowY: true
                }"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    <market-icons size="16" :items="[item.key]" />
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-icon>
                    <market-icons size="16" :items="[item.key]" />
                  </v-list-item-icon>
                  {{ item[`name_${$i18n.locale}`] }}
                </template>
              </v-select>
            </v-list-item>
            <v-list-item>
              <v-select
                flat
                multiple
                small-chips
                return-object
                clearable
                v-model="valueSectors"
                :items="filterSectorsGroups"
                :filter="((item, queryText, itemText) => {
                  return valueMarkets.includes(item.groupId);
                })"
                item-value="key"
                :item-text="`name_${$i18n.locale}`"
                :label="$t('theme.filterSectors')"
                :menu-props="{
                  closeOnContentClick: true,
                  auto: true,
                  overflowY: true
                }"
              >
                <template v-slot:selection="{ item }">
                  <span class="chipSector" :style="{ 'background': item.color }">
                    <small>{{ item[`name_${$i18n.locale}`] }}</small>
                  </span>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <template v-if="data.item.header">
                    <v-list-tile-content v-text="data.item.header" />
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-item-icon>
                        <span
                          class=""
                          :style="`background:${data.item.color};height:14px;width:14px;display:flex;`"
                        ></span>
                      </v-list-item-icon>
                      <v-list-tile-title v-html="data.item[`name_${$i18n.locale}`]" />
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions class="text-right">
            <v-btn
              color="primary"
              @click.prevent="handlerSubmit"
            >
              {{ $t('theme.search') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-menu>
  </div>
</template>
<script>
import { groupBy, utf8_to_b64 } from '@/core/utils'
import Languages from '@/components/file/Languages'
import MarketIcons from '@/components/file/Markets'
export default {
  name: "Headband",
  data () {
    return {
      skus: [],
      isLoading: false,
      items: [],
      model: null,
      search: null,

      filterActive: false,
      filterLanguages: [],
      filterMarkets: [],
      filterSectors: [],
      valueLanguages: [],
      valueMarkets: [],
      valueSectors: [],
      activeLanguages: false,
      activeMarkets: false,
      activeSectors: false,
    }
  },

  components: {
    MarketIcons,
    Languages
  },

  watch: {
    // search (val) {
    //   val && val !== this.model && this.querySelections(val)
    // },
    search (val) {
      if (!val && val !== "" && val === this.model) {
        return
      }

      this.items = []
      this.isLoading = false
      this.querySelections(val)
    }
  },

  mounted () {
    this.skus = this.$store.getters['home/termsType']('pumps').map(k => k.key)
    this.filterLanguages = this.$store.getters['home/termsType']('languages')
    this.filterMarkets = this.$store.getters['home/termsType']('markets')
  },

  computed: {

    filterSectorsGroups () {
      const filterSectors = this.$store.getters['home/termsType']('sectors')
      const optionsGroup = groupBy(filterSectors, 'market')

      let objGroup = []
      let sectorsDisplay = Object.keys(optionsGroup)
      if (this.valueMarkets.length !== 0) {
        const doudou = groupBy(this.valueMarkets, 'key')
        sectorsDisplay = Object.keys(doudou)
      }

      for (let group of sectorsDisplay) {
        objGroup.push({ groupId: group, header: this.filterMarkets.filter(f => f.key === group)[0][`name_${this.$i18n.locale}`] })

        const secteursOrder = filterSectors.filter(f => f.market === group)
        for (let index = 0; index < secteursOrder.length; index++) {
          const element = secteursOrder[index]
          element.group = group
          element.groupId = group
          objGroup.push(element) 
        }
      }
      return objGroup
    },
  },

  methods: {

    querySelections (val) {
      // this.isLoading = true
      setTimeout(() => {
        if (val.length >= 2) {
          this.search = val
          this.items = this.skus.filter(sku => new RegExp(`^${val}`, "gi").test(sku))
        }
        // this.isLoading = false
      })
    },

    handlerSubmit () {
      const wordsQuery = this.search || ""
      if (wordsQuery.length >= 2) {
        this.isLoading = true

        let test = {}

        const dataLanguages = this.valueLanguages.map(l => l.key)
        if (dataLanguages.length !== 0) {
          test.l = dataLanguages.join(',')
        }

        const dataMarkets = this.valueMarkets.map(l => l.key)
        if (dataMarkets.length !== 0) {
          test.m = dataMarkets.join(',')
        }

        const dataSectors = this.valueSectors.map(l => l.key)
        if (dataSectors.length !== 0) {
          test.s = dataSectors.join(',')
        }

        const queries = Object.keys(test).length !== 0 ? test : null

        const isPump = this.$store.getters["home/checkPump"](wordsQuery)
        if (isPump.length !== 0) {
          this.$router.push({
            name: 'SinglePump',
            params: { sku: wordsQuery },
            query: { ...queries }
          })
          this.isLoading = false
        } else {
          let outRouter = {
            name: 'HomeSearch',
            params: { words: utf8_to_b64(wordsQuery) },
          }
          this.$router.push({
            ...outRouter,
            query: { ...queries }
          })
          this.isLoading = false
        }
      }
    }
  }
}
</script>
